export default "__VITE_ASSET__cBZ8xMK7__"